import { ChangeDetectionStrategy, Component } from '@angular/core';

import { DsFormlyFieldType } from '@app/forms/formly/types/ds-formly-field';

@Component({
  selector: 'currency-field',
  templateUrl: './currency-field.component.html',
  styleUrls: ['./currency-field.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CurrencyFieldComponent extends DsFormlyFieldType {}
